import React from 'react'

import { useResponsiveSettings } from '../../../providers/ResponsiveSettingsProvider'
import useStyles from './styles'
import { ArrowLeft2 } from 'iconsax-react'

type SettingsPageProps = {
  above?: React.ReactNode
  title?: string
  disableBottomPadding?: boolean
  children: React.ReactNode
}

const SettingsPage: React.FC<SettingsPageProps> = ({
  above,
  title,
  disableBottomPadding,
  children
}) => {
  const { isSmall, setSelecting } = useResponsiveSettings()

  const classes = useStyles({ isSmall, disableBottomPadding })

  return (
    <div className={classes.root}>
      {above}

      {title && (
        <div className={classes.title}>
          {isSmall && (
            <ArrowLeft2 onClick={() => setSelecting(true)} className='icon' />
          )}
          {title}
        </div>
      )}

      {children}
    </div>
  )
}

export default SettingsPage
